export default "__VITE_ASSET__DlIVSoou__"